import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { InternalFieldName } from 'react-hook-form/dist/types/fields';
import Form from '../Crud/Form';
import ReminderType from '../../enums/ReminderType';
import CustomButton from '../CustomButton/CustomButton';

export interface ReminderFormFields {
  description: string;
  isRequired: boolean;
  isActive: boolean;
}

interface ReminderFormProps {
  isLoading: boolean;
  title: string;
  formFields: ReminderFormFields;
  formErrors: Record<string, any>;
  onSubmit: (data: any) => void;
}

function addServerErrors<T>(
  errors: { [P in keyof T]?: string[] },
  setError: any
) {
  return Object.keys(errors).forEach((key) => {
    setError(key as keyof T, {
      type: 'server',
      message: errors[key as keyof T]!.join('. '),
    });
  });
}

export default function ReminderForm({
  isLoading,
  title,
  formFields,
  formErrors,
  onSubmit,
}: ReminderFormProps) {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
  } = useForm<ReminderFormFields>();

  useEffect(() => {
    reset(formFields);
  }, [formFields]);

  useEffect(() => {
    let shouldFocus = true;
    Object.keys(formErrors || {}).forEach((field: InternalFieldName) => {
      addServerErrors(formErrors, setError);

      shouldFocus = false;
    });
  }, [formErrors]);

  return (
    <Form isLoading={isLoading} title={title} onSubmitCallback={() => {}}>
      <form>
        <div className='mt-2 mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor='inputLabel' className='form-label'>
            Descrição
          </label>
          <input
            {...register('description', { required: true })}
            className='form-control'
            id='inputLabel'
            placeholder='Descrição'
            type='text'
            required
          />
          {errors.description && (
            <div id='emailHelp' className='form-text text-danger'>
              {errors.description.message}
            </div>
          )}
        </div>
        <div className='row align-items-center'>
          <div className='col-sm-3'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='isRequired'
                {...register('isRequired')}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className='form-check-label' htmlFor='isRequired'>
                Obrigatório
              </label>
            </div>
          </div>
          <div className='col-sm-3'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='isActive'
                {...register('isActive')}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className='form-check-label' htmlFor='isActive'>
                Ativo
              </label>
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-end gap-2'>
          <Link to='/reminders' className='btn btn-secondary'>
            Cancelar
          </Link>
          <CustomButton
            type='button'
            className='btn btn-primary'
            handleClick={handleSubmit(onSubmit)}
          >
            Salvar
          </CustomButton>
        </div>
      </form>
    </Form>
  );
}
